<template>
    <body class="mob-overflow">
        <div class="resrc_mainview_div">
            <header class="mob-display common--header">
                <b-row class="marginTopAlignment">
                    <b-col cols="2" v-on:click="backAction()"><img src="images/Back_white.svg" alt="" /></b-col>
                    <b-col cols="8" class="header-title text-center">RESOURCES</b-col>
                </b-row>
                <!-- <b-row class="marginTopAlignment">
        <b-col class="mob-display" cols="2" v-on:click="backAction()">
          <img src="images/Back_white.svg" alt />
        </b-col>
        <b-col cols="8" class="mob-display header-title text-center">RESOURCES</b-col>
        <b-col cols="11" class="desk_display header-title text-center">RESOURCES</b-col>
        <b-col cols="1" v-on:click="gomenu()" class="centering-block desk_display textalign_right">
          <img src="images/home_desktop.png" alt v-b-toggle.sidebar-backdrop />
        </b-col>
      </b-row> -->
            </header>
            <header class="desk_display">
                <div id="header_content" class="common--header">
                    <p class="alignleft"></p>
                    <p class="aligncenter header-title">RESOURCES</p>
                    <p class="alignright" v-on:click="gomenu()">
                        <img src="images/Home@2x.png" alt v-b-toggle.sidebar-backdrop />
                    </p>
                </div>
                <div style="clearaligncenter: both"></div>
            </header>
            <!-- <b-container class="bv-example-row res_cont_height mob_col_padding"> -->
            <b-container class="bv-example-row mob_col_padding">
                <b-row class="justify-content-md-center dev_lr_margin row_height">
                    <b-col lg="12" class="mob_col_padding dev_position">
                        <!-- <b-col class="xs_col col-sm-10 col-md-7 col-lg-5 mob_col_padding dev_position"> -->
                        <div class="resourceList" v-if="!showError">
                            <div class="resourceContent">
                                <p class="resourceTitle">{{ resourcesTitle }}</p>
                                <table class="resourceTableStyle footer_bottom">
                                    <!-- <tr>
                                        <th class="resourceStaticLabelStyle">{{ Items.head }}</th>
                                    </tr> -->
                                    <tr v-for="item in Items.entries" v-bind:key="item.sid" :id="item.sid">
                                        <td
                                            v-b-toggle="'id-' + item.sid"
                                            class="buttonhighlight resourceLabelWithBorder"
                                            :id="item.sid"
                                            :value="item.qnme"
                                        >
                                            <label style="width: 80%">{{ item.qnme }}</label>
                                            <span class="when-closed">
                                                <img class="resourceArrowImage" src="images/Down_arrow.png" />
                                            </span>
                                            <span class="when-opened">
                                                <img class="resourceArrowImage" src="images/Up_arrow.png" />
                                            </span>
                                        </td>
                                        <b-collapse :id="'id-' + item.sid">
                                            <b-card class="resource-form-collapse-detail-label" :for="item.sid">{{ item.answ }}</b-card>
                                        </b-collapse>
                                    </tr>
                                    <tr>
                                        <th class="resourceStaticLabelStyle">{{ privacy.head }}</th>
                                    </tr>
                                    <tr v-for="privacy in privacy.entries" v-bind:key="privacy.sid" :id="privacy.sid">
                                        <td
                                            v-b-toggle="'id-' + privacy.sid"
                                            class="buttonhighlight resourceLabelWithBorder"
                                            :id="privacy.sid"
                                            :value="privacy.qnme"
                                        >
                                            <label style="width: 80%">{{ privacy.qnme }}</label>
                                            <span class="when-closed">
                                                <img class="resourceArrowImage" src="images/Down_arrow.png" />
                                            </span>
                                            <span class="when-opened">
                                                <img class="resourceArrowImage" src="images/Up_arrow.png" />
                                            </span>
                                        </td>
                                        <b-collapse :id="'id-' + privacy.sid">
                                            <b-card class="resource-form-collapse-detail-label" :for="privacy.sid">{{
                                                privacy.answ
                                            }}</b-card>
                                        </b-collapse>
                                    </tr>
                                    <tr>
                                        <th class="resourceStaticLabelStyle">{{ resources.head }}</th>
                                    </tr>
                                    <tr
                                        class="resourceListStyle"
                                        v-for="res in resources.entries"
                                        v-bind:key="res.title"
                                        :id="res.title"
                                        v-on:click="showNews(res.url)"
                                    >
                                        <td>
                                            <img :src="res.img" alt class="resourceImgStyle" />
                                            <p class="resourceCellStyle" :id="res.title" :value="res.title">{{ res.title }}</p>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
            <b-container class="text_cntr">
                <div v-if="showError" class="successMsgdiv resrc_mar_top footer_bottom">
                    <label class="thankyouText">{{ errorMessage }}</label>
                </div>
            </b-container>
        </div>
        <Footer></Footer>
    </body>
</template>

<script>
import apiCall from "@/services/api/apicall";
import { store } from "@/store.js";
import Footer from "@/components/footer";

export default {
    name: "Home",
    components: {
        Footer,
    },
    data() {
        return {
            testing: [],
            Items: [],
            privacy: [],
            resources: [],
            store: store,
            user: {
                symptom_checker: [],
            },
            showError: false,
            errorMessage: "",
        };
    },
    methods: {
        backAction() {
            this.$router.push({ path: "/app-home" });
        },
        showNews(url) {
            window.open(url, "_blank");
        },
        gomenu() {
            this.$router.push({ path: "/app-home" });
        },
    },
    mounted() {
        if (navigator.onLine) {
            this.showError = false;
            apiCall
                .apiServiceCall("Get", "", "/lookup/faq-resource/", "", "")
                .then((response) => {
                    if (response.data.status == 1) {
                        for (var i = 0; i < response.data.data.length; i++) {
                            if (response.data.data[0]) {
                                this.Items = response.data.data[0];
                            }
                            if (response.data.data[1]) {
                                this.privacy = response.data.data[1];
                            }
                            if (response.data.data[2]) {
                                this.resources = response.data.data[2];
                            }
                        }
                        for (var j = 0; j < this.Items.entries.length; j++) {
                            var itemText = "About";
                            this.Items.entries[j].sid = itemText.concat(j + 1);
                        }
                        for (var k = 0; k < this.privacy.entries.length; k++) {
                            var privacyText = "Privacy";
                            this.privacy.entries[k].sid = privacyText.concat(k + 1);
                        }
                        for (var img = 0; img < this.resources.entries.length; img++) {
                            if (this.resources.entries[img].title == "Privacy and Terms of Use") {
                                this.resources.entries[img].img = "images/privacy_logo.png";
                            } else {
                                var link = this.apiURL;
                                this.resources.entries[img].img = link.concat(this.resources.entries[img].img);
                            }
                        }
                    } else {
                        this.showError = true;
                        this.errorMessage = response.data.message;
                    }
                })
                .catch((error) => {
                    if (error.response.status == 500) {
                        this.showError = true;
                        this.errorMessage = this.serverProblem;
                    } else if (error.response.status == 401) {
                        setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                    } else if (error.response.status == 504) {
                        this.signout();
                    } else {
                        this.showError = true;
                        this.errorMessage = error.response.data.message;
                    }
                });
        } else {
            this.showError = true;
            this.errorMessage = this.checkInternetConnection;
        }
    },
};
</script>
<style scoped>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
    display: none;
}
</style>